import React, { Component, PropTypes } from 'react';
import { get } from 'lodash';
import Status from './StatusComponent';
import { Tripadvisor } from '../../../../constants/ManageApps';
import StatusMessage from './StatusMessageComponent';

class TripadvisorSection extends Component {
    render() {
        const status = get(this.props.configurationObject, 'status');
        const chainStatus = get(this.props.chainConfigurationObject, 'status');

        return (
            <section className="content-section">
                <Status
                    isDisabled={this.props.isDisabled}
                    objectName="tripadvisor"
                    value={status}
                    parentValue={chainStatus}
                    level={this.props.level}
                    setValue={(key, value) => {
                        this.props.setValue(key, value);
                    }}
                    appName={Tripadvisor.appName}
                />
                <StatusMessage appName={Tripadvisor.appName} value={status} parentValue={chainStatus} />
            </section>
        );
    }
}

TripadvisorSection.propTypes = {
    configurationObject: PropTypes.obj,
    chainConfigurationObject: PropTypes.obj,
    level: PropTypes.string,
    setValue: PropTypes.func
};

export default TripadvisorSection;



// WEBPACK FOOTER //
// ./src/components/pages/manage/apps/TripadvisorSection.js